export const NAVIGATION_NAVIGATE: string = 'DOGLEY/NAVIGATION_NAVIGATE'
export const NAVIGATION_BACK: string = 'DOGLEY/NAVIGATION_BACK'
export const NAVIGATION_FORWARD: string = 'DOGLEY/NAVIGATION_FORWARD'
